__turbopack_context__.v({
  "learnMoreButtons": "learnMore-module-scss-module__qSW_bW__learnMoreButtons",
  "learnMoreContainer": "learnMore-module-scss-module__qSW_bW__learnMoreContainer",
  "learnMoreDescription": "learnMore-module-scss-module__qSW_bW__learnMoreDescription",
});
